module.exports = __webpack_public_path__ + "6ae0ab3b.svg";